module.exports = "/shifts/components/recurrenceOptionsComponent-ed1c05.html";